/*
 * Buy 1, Get 1 Free — Portable Water Bottle (Elite theme).
 * Doubles the submitted quantity on this product's Add to Cart form, in a
 * single request, before Elite's own product-form.js reads the FormData.
 * Pricing correctness (making half the units free) is handled entirely by
 * the native Shopify automatic discount "Buy 1, Get 1 Free — Water Bottle" —
 * this script only affects how many units get added to the cart.
 *
 * Unlike the Cooling Mat, all 4 Water Bottle variants are BOGO-eligible
 * (see BOGO-CONFIGURATION.md), so there is no ineligible-variant check here.
 *
 * Uses form.elements (not form.querySelector) because Elite's quantity
 * input is associated to the form via the `form="..."` attribute rather
 * than being a DOM descendant of the <form> element.
 */
(function () {
  function doubleQuantity(event) {
    var form = event.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    var quantityInput = form.elements ? form.elements.namedItem('quantity') : null;
    if (!quantityInput) return;

    var requested = parseInt(quantityInput.value, 10) || 1;
    quantityInput.value = requested * 2;
    quantityInput.dataset.caniorasBogoPaidQuantity = requested;
  }

  document.addEventListener('submit', doubleQuantity, true);
})();
